import React, { useEffect } from 'react';
import Aos from "aos";
import "aos/dist/aos.css";
import { ProductCard } from './ProductCard.js'; 
import './bigfix.css';

// Import images...
import img1 from "../../assets/inventory/Reduce+risk+and+manage+the+entire+endpoint+system+lifecycle.png";
import img2 from "../../assets/compliance/Improve+visibility+and+reduce+risk.png";
import img3 from "../../assets/compliance/Prioritize+remediation+with+compliance.png";
import img5 from "../../assets/inventory/Improve+security+posture.png";
import img4 from "../../assets/inventory/Increase+efficiency+by+streamlining.png";
import img6 from "../../assets/compliance/Pass+audits+and+avoid+fines+with+continuous+compliance.png";
import img7 from "../../assets/workspace/One+solution+to+manage+and+secure+all+end+user+workspaces.png";
import img8 from "../../assets/inventory/Deliver+comprehensive+visibility (1).png";
import img9 from "../../assets/inventory/Reduce+audit+fines+and+software+costs.png";
import img10 from "../../assets/inventory/Maximize+ROI+with+unparalleled+scalability.png";
import img11 from "../../assets/inventory/Deliver+comprehensive+visibility.png";

const bigFixModules = [
  {
    title: "Unified Endpoint Management",
    image: img1,
    description:
      "A single, unified architecture to effectively manage and secure all servers, desktops, and mobile devices—whether on-premise, at home, or in the cloud.",
    description1:
      "Leverages AI technology to assure compliance and streamline management across diverse endpoint environments.",
  },
  {
    title: "Continuous Compliance Monitoring",
    image: img5,
    description:
      "Monitor and assess compliance effectiveness in real-time. Gain instant insights into endpoint status and security exposures.",
    description1:
      "The robust Compliance Analytics Engine offers out-of-the-box reports on security configurations and patching status.",
  },
  {
    title: "Patch Compliance & Reporting",
    image: img2,
    description:
      "Efficiently manage the entire patching lifecycle. Analyze compliance effectiveness with real-time status updates across all deployments.",
    description1:
      "Provides instant insights into security configurations, patching gaps, and vulnerabilities to reduce risk dramatically.",
  },
  {
    title: "Improve Security Posture",
    image: img3,
    description:
      "Bridge the gap between IT and Security teams. Set and monitor security compliance policies for software and configurations.",
    description1:
      "Ensures enterprise-wide security through rapid health checks and comprehensive compliance reporting.",
  },
  {
    title: "Insights for Vulnerability Remediation",
    image: img11,
    description:
      "Integrates with vulnerability data sources to guide users on the best patch and configuration settings to remediate discovered threats.",
    description1:
      "Prioritize and take action on vulnerabilities faster to reduce your attack surface and improve overall security.",
  },
  {
    title: "Efficient Inventory Automation",
    image: img4,
    description:
      "Automate inventory tasks to streamline operations and cut manual resource hours. Get accurate, up-to-date visibility into your assets.",
    description1:
      "Manages large-scale endpoint deployments efficiently, significantly reducing costs compared to traditional manual methods.",
  },
  {
    title: "Software Distribution",
    image: img7,
    description:
      "Deploy software to endpoints across your entire network from a single, centralized location with speed and reliability.",
    description1:
      "Maintain complete control and visibility into the software delivery and installation process.",
  },
  {
    title: "OS Deployment",
    image: img8,
    description:
      "A consolidated solution to quickly deploy new workstation and server operating systems throughout the network.",
    description1:
      "Part of the Lifecycle Management suite, it simplifies the complex process of OS provisioning and migration.",
  },
  {
    title: "Client Device Management",
    image: img6,
    description:
      "Comprehensively manage the entire lifecycle of client devices, from initial discovery to issue resolution.",
    description1:
      "Streamline IT tasks, empower end-users with self-service capabilities, and minimize service desk tickets.",
  },
  {
    title: "Remote Control",
    image: img10,
    description:
      "Securely access and troubleshoot remote endpoints to resolve issues quickly, regardless of their location.",
    description1:
      "Facilitates communication between different components, clients, and endpoints within the BigFix environment.",
  },
  {
    title: "Modern Client Management",
    image: img1, // Reusing an image here, consider a unique one
    description:
      "Manage modern devices (like via MDM) that don't have a BigFix agent, alongside traditional agent-based devices.",
    description1:
      "The BigFix WebUI provides a single pane of glass for managing a diverse fleet of devices.",
  },
  {
    title: "Centralized Management at Scale",
    image: img9,
    description:
      "Manage up to 300,000 endpoints from a single management server, regardless of location, connection type, or OS.",
    description1:
      "Uses a single, intelligent agent supporting more than 100 operating system versions for unparalleled scalability.",
  },
];

export const Inventory = () => {
  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  return (
    // Use the more generic class name
    <section className="product-section">
      {/* 1. Introduction / Hero Section */}
      <div className="product-intro-container" data-aos="fade-up">
        <h1 className="product-title">BigFix: Unified Endpoint Management & Security</h1>
        <p className="product-subtitle">
          Discover, manage, and secure every endpoint across your enterprise—on-prem, cloud, or remote—from a single, automated platform.
        </p>
      </div>

      {/* 2. The Cards Grid */}
      <div className="product-cards-grid">
        {bigFixModules.map((module, index) => (
          <div key={index} data-aos="fade-up" data-aos-delay={index * 100}>
            {/* Use the generic ProductCard component */}
            <ProductCard {...module} />
          </div>
        ))}
      </div>
    </section>
  );
};